module.exports = __webpack_public_path__ + "static/mockup_emily_sito-0cfee6254cf13418f2dfca3341fcca57.jpg";